import {
  PC_BANG_USER_LOGIN_FAIL_RESPONSE,
  PC_BANG_USER_LOGIN_REQUEST,
  CURRENT_USER_DETAIL_RESPONSE,
  PC_BANG_USER_LOGOUT,
} from '../actions/user.actions';

export default function user(state = {}, action) {
  switch (action.type) {
    case PC_BANG_USER_LOGIN_REQUEST: {
      let nextState = {...state};
      nextState.username = '';
      return nextState;
    }
    case PC_BANG_USER_LOGIN_FAIL_RESPONSE: {
      let nextState = {...state};
      nextState.loginFailCount += 1;
      return nextState;
    }
    case CURRENT_USER_DETAIL_RESPONSE: {
      let nextState = action.currentUserDetail;
      return nextState;
    }
    case PC_BANG_USER_LOGOUT: {
      sessionStorage.removeItem('token');
      let nextState = {};
      return nextState;
    }
  }
  return state;
}
